import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";
import CreaServicios from "../Modals/crear/CreaServicios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import {
  obtenerSedes,
  obtenerServiciosPorSolicitud,
  obtenerServiciosTodos,
  sedesPorInstitucionId,
} from "../../Services/Rest";
import { useParams } from "react-router-dom";

const urlA = obtenerSedes;
const urlU = sedesPorInstitucionId;
const cookie = new Cookies();

const InfoServicios = (props) => {
  let { id } = useParams();
  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint = urlA;
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint = urlU + cookie.get("institucionid");
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint = urlU + id;
  }
  if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;

  const [list2, setList2] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList2(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList2]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [postSede, setPostSede] = useState([]);
  const [postComplejidad, setPostComplejidad] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaComplejidadSede",
      data: {
        sedeId: selectedValue,
        institucionId: cookie.get("institucionid"),
        complejidad: postComplejidad,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Complejidad asignada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };
  const servicioInstitucion = (e) => {
    e.preventDefault(e);
    if (selectedValue == "") {
      window.alert("debe seleccionar la sede");
      window.location.reload("/");
    }
    window.location.href = "/#/ServicioSede/" + selectedValue;
  };
  const [selectedValue, setSelectedValue] = useState(""); // Estado para el valor seleccionado
  const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  console.log("sede " + selectedValue);
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Complejidad de la sede
                </h6>
                <hr />
                <div>
                  {cookie.get("tipo_Usuario") == 1 ? (
                    <input
                      type="text"
                      placeholder="Buscar sede"
                      className="form-control form-control-user"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  ) : (
                    <h></h>
                  )}
                  <hr />
                  <select
                    className="btn btn-secondary btn-user btn-block"
                    onChange={handleSelectChange}
                    value={selectedValue}
                  >
                    <option value="">Seleccione la sede</option>
                    {list2
                      .filter((item) =>
                        item.nombre
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase()),
                      )
                      .map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="row"></div>
                <hr />
                {cookie.get("tipo_Usuario") == 2 ? (
                  <div className="form-group row">
                    <div className="col-sm-12">
                      <label className="text-primary">
                        Seleccione la Complejidad{" "}
                      </label>{" "}
                      <p />
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="inlineRadioOptions"
                          id="inlineRadio3"
                          value="Baja"
                          onChange={(e) => setPostComplejidad(e.target.value)}
                        />
                        <label class="form-check-label" for="inlineRadio3">
                          Baja
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="inlineRadioOptions"
                          id="inlineRadio4"
                          value="Media"
                          onChange={(e) => setPostComplejidad(e.target.value)}
                        />
                        <label class="form-check-label" for="inlineRadio4">
                          Media
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="inlineRadioOptions"
                          id="inlineRadio4"
                          value="Alta"
                          onChange={(e) => setPostComplejidad(e.target.value)}
                        />
                        <label class="form-check-label" for="inlineRadio4">
                          Alta
                        </label>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {cookie.get("tipo_Usuario") == 2 ? (
                  <a>
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={postData}
                    >
                      Guardar
                    </button>
                  </a>
                ) : (
                  <></>
                )}
                <hr />
                <a>
                  <button
                    className="btn btn-primary btn-user btn-block"
                    onClick={servicioInstitucion}
                  >
                    ver servicios de la sede
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoServicios;
